/* Tack & Tweed: Consign with Us (v2). Hero video, estimator (only if switched on), What we accept, ship-or-local chooser, FAQ.
   No tracking, no network calls. Safe to load more than once. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; };
  var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };

  function hero(root) {
    if (!once(root, 'ttReady')) return;
    var vids = $$('video', root), btn = root.querySelector('[data-tt-vid-toggle]'), paused = reduce;
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.controls = false; v.removeAttribute('controls'); v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1; });
    var sync = function () { vids.forEach(function (v) { if (!paused && v.offsetParent !== null) play(v); else v.pause(); }); };
    sync();
    var mq = window.matchMedia('(min-width: 900px)'); if (mq.addEventListener) mq.addEventListener('change', sync);
    if (btn && !reduce) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        paused = !paused; sync();
        btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        btn.innerHTML = paused ? '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M4 2l12 7-12 7z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><rect x="3" y="2" width="4" height="14" fill="currentColor"/><rect x="11" y="2" width="4" height="14" fill="currentColor"/></svg>';
      });
    }
  }

  /* Estimator: runs only when the section setting "Show the estimator" is on (data-estimator="on"). Reads tiers from the table. */
  function estimator(sec) {
    if (sec.dataset.estimator !== 'on' || !once(sec, 'ttReady')) return;
    var input = sec.querySelector('[data-est-input]'); if (!input) return;
    var rows = $$('tr[data-tier]', sec), tiers = rows.map(function (r) { return { min: +r.dataset.min, cash: +r.dataset.cash, credit: +r.dataset.credit, row: r }; });
    var q = function (s) { return sec.querySelector(s); }, txt = q('[data-est-text]'), res = q('[data-est-results]'), msg = q('[data-est-msg]');
    var quick = $$('[data-price]', sec), MIN = +sec.dataset.minAccept || 40, timer;
    var money = function (n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
    function setActive(t) {
      rows.forEach(function (r) {
        var on = t && r === t.row, cur = r.querySelector('.tt-cur');
        r.classList.toggle('is-active', !!on);
        if (on && !cur) { cur = document.createElement('span'); cur.className = 'tt-vh tt-cur'; cur.textContent = ' (your estimate)'; r.firstElementChild.appendChild(cur); }
        if (!on && cur) cur.remove();
      });
    }
    function calc() {
      var raw = (input.value || '').replace(/[$,\s]/g, ''), n = parseFloat(raw);
      quick.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.price === n)); });
      if (raw === '' || isNaN(n) || !/^\d*\.?\d*$/.test(raw) || n <= 0) { res.hidden = true; setActive(null); msg.textContent = ''; return; }
      if (n < MIN) { res.hidden = true; setActive(null); msg.textContent = txt.dataset.under; return; }
      var t = null, i; tiers.forEach(function (x) { if (n >= x.min) t = x; });
      if (!t) { res.hidden = true; setActive(null); msg.textContent = txt.dataset.under; return; }
      res.hidden = false; setActive(t);
      q('[data-est-cash]').textContent = 'about ' + money(n * t.cash / 100);
      q('[data-est-credit]').textContent = 'about ' + money(n * t.credit / 100);
      q('[data-est-cash-rate]').textContent = t.cash + '% of the selling price';
      q('[data-est-credit-rate]').textContent = t.credit + '% of the selling price';
      var notes = [], top = tiers[tiers.length - 1];
      if (top && n >= top.min) notes.push(txt.dataset.special);
      for (i = 1; i < tiers.length; i++) { if (n > tiers[i].min - 1 && n < tiers[i].min) notes.push(txt.dataset.gap); }
      msg.textContent = notes.join(' ');
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(calc, 250); });
    q('[data-est-form]').addEventListener('submit', function (e) { e.preventDefault(); calc(); });
    quick.forEach(function (b) { b.addEventListener('click', function () { input.value = b.dataset.price; calc(); }); });
    calc();
  }

  function accept(sec) {
    if (!once(sec, 'ttReady')) return;
    var chips = $$('[data-cat]', sec).filter(function (c) { return c.tagName === 'BUTTON'; });
    var answer = sec.querySelector('[data-cat-answer]'), glance = $$('.tt-glance li', sec);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var on = c.getAttribute('aria-pressed') !== 'true';
        chips.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        glance.forEach(function (li) { li.classList.remove('is-active'); });
        if (!on) { answer.innerHTML = ''; var em = document.createElement('em'); em.textContent = answer.dataset.empty; answer.appendChild(em); return; }
        c.setAttribute('aria-pressed', 'true');
        var li = glance.filter(function (l) { return l.dataset.cat === c.dataset.cat; })[0]; if (!li) return;
        li.classList.add('is-active');
        answer.innerHTML = ''; var s = document.createElement('strong'); s.textContent = li.children[0].textContent + ':';
        answer.appendChild(s); answer.appendChild(document.createTextNode(' ' + li.children[1].textContent));
      });
    });
    var data = sec.querySelector('[data-brands]'), form = sec.querySelector('[data-brand-form]'); if (!data || !form) return;
    var list = []; try { list = String(JSON.parse(data.textContent) || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean); } catch (e) {}
    var norm = function (s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
    var base = function (s) { return s.replace(/\s*[\*(].*$/, ''); };
    var dl = sec.querySelector('[data-brand-list]'), bIn = sec.querySelector('[data-brand-input]'), bOut = sec.querySelector('[data-brand-out]'), bt;
    list.forEach(function (b) { var o = document.createElement('option'); o.value = base(b); dl.appendChild(o); });
    function check(final) {
      var qv = bIn.value.trim(), n = norm(qv), hit = null;
      if (!qv) { bOut.textContent = ''; return; }
      for (var i = 0; i < list.length; i++) { if (norm(list[i]) === n || norm(base(list[i])) === n) { hit = list[i]; break; } }
      if (hit) bOut.textContent = data.dataset.hit + (hit !== base(hit) ? ' (Listed as “' + hit.replace(/\*/g, '') + '”.)' : '');
      else bOut.textContent = final ? data.dataset.miss : '';
    }
    bIn.addEventListener('input', function () { clearTimeout(bt); bt = setTimeout(function () { check(false); }, 300); });
    bIn.addEventListener('change', function () { check(true); });
    form.addEventListener('submit', function (e) { e.preventDefault(); check(true); });
  }

  /* Ship or local: same consignor form either way; fills an editable starter line only if the message box is empty or still a starter. */
  function chooser(sec) {
    if (!once(sec, 'ttReady')) return;
    var btns = $$('[data-choice]', sec);
    var starters = btns.map(function (b) { return b.dataset.starter; });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        $$('[data-chosen-for]', sec).forEach(function (p) { p.hidden = p.dataset.chosenFor !== b.dataset.choice; });
        var line = document.querySelector('[data-chosen-line]'); if (line) { line.textContent = b.dataset.line; line.hidden = false; }
        var formSec = document.querySelector('.shopify-section--consignor-signup-form') || document;
        var box = formSec.querySelector('form textarea');
        if (box && (box.value === '' || starters.indexOf(box.value) > -1)) box.value = b.dataset.starter;
        var target = document.querySelector(sec.dataset.target || '#form');
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var first = formSec.querySelector('form input:not([type=hidden])');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 500);
      });
    });
  }

  function faq(root) {
    if (!once(root, 'ttReady')) return;
    var d = $$('details', root);
    d.forEach(function (x) { x.addEventListener('toggle', function () { if (x.open) d.forEach(function (o) { if (o !== x) o.open = false; }); }); });
  }

  function init() {
    $$('[data-tt-hero]').forEach(hero);
    $$('[data-estimator]').forEach(estimator);
    $$('[data-tt-accept]').forEach(accept);
    $$('[data-tt-chooser]').forEach(chooser);
    $$('[data-tt-faq]').forEach(faq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
